export const getInternalValue = (value: (Date | undefined)[]) => {
  if (value.includes(undefined)) {
    return []
  }

  return value as Date[]
}
